import { Link } from '@spotahome/ui-library';
import { trans, getResourcePath } from '@spotahome/soyuz/client';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';

import './AboutPress.scss';

const AboutPress = () => (
  <div className="wrapper">
    <SectionHeading
      size="large"
      text={trans('about-us.press.title')}
      className="mb-xl"
    />
    <div className="three-cols mb-xl">
      <div className="about-press_item">
        <Link
          href="https://www.elconfidencial.com/tecnologia/2017-03-15/airbnb-spotahome-badi-alojamiento-startups_1348071/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <figure className="about-press_item__logo">
            <img
              src={getResourcePath('/images/about-us/confidencial-icon.jpg')}
              alt="confidencial icon"
            />
          </figure>
          <p className="about-press_item__title">
            {trans('about-us.press.item-1.text')}
          </p>
          <p className="about-press_item__link">
            https://www.elconfidencial.com/tecnologia/2017-03-15/airbnb-spotahome-badi-alojamiento-startups_1348071/
          </p>
        </Link>
      </div>

      <div className="about-press_item">
        <Link
          href="http://www.ticbeat.com/entrevistas/alejandro-artacho-spotahome-somos-el-amazon-del-sector-inmobiliario/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <figure className="about-press_item__logo">
            <img
              src={getResourcePath('/images/about-us/ticbeat-icon.jpg')}
              alt="ticbeat"
            />
          </figure>
          <p className="about-press_item__title">
            {trans('about-us.press.item-2.text')}
          </p>
          <p className="about-press_item__link">
            http://www.ticbeat.com/entrevistas/alejandro-artacho-spotahome-somos-el-amazon-del-sector-inmobiliario/
          </p>
        </Link>
      </div>

      <div className="about-press_item">
        <Link
          href="http://www.telva.com/trabajo/exito-laboral/2016/11/28/583c111cca47417e738b4623.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <figure className="about-press_item__logo">
            <img
              src={getResourcePath('/images/about-us/telva-icon.jpg')}
              alt="telva icon"
            />
          </figure>
          <p className="about-press_item__title">
            {trans('about-us.press.item-3.text')}
          </p>
          <p className="about-press_item__link">
            http://www.telva.com/trabajo/exito-laboral/2016/11/28/583c111cca47417e738b4623.html
          </p>
        </Link>
      </div>
    </div>
  </div>
);

export default AboutPress;
